<template>
    <div v-html="data.content"></div>
</template>

<script>
    import InfoService from '../../../app-front/services/api/InfoService';

    import './text-page.scss'

    export default {
        name: "TextPage",
        props: {
            pageName: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                metaUrl: '/info/' + this.pageName,
                breadcrumbsData: {
                    page: 'textPage',
                    data: {
                        pageName: this.pageName
                    }
                },
                data: {},
                pages: {
                    about: "o-nas",
                    privacyPolicy: "politika-konfidentsialnosti",
                    termsOfUse: "usloviya-polzovaniya",
                    purchasesAtAgrolink: "zakupki-na-agrolink"
                },
                founders: [
                    {
                        id: 1,
                        src: '//cdn.agro-mp.local/images/about-us/founders/feodoridi-founder.jpg',
                        name: 'Георгий Феодориди'
                    },
                    {
                        id: 2,
                        src: '//cdn.agro-mp.local/images/about-us/founders/feodoridi-founder2.jpg',
                        name: 'Александр Феодориди'
                    },
                    {
                        id: 3,
                        src: '//cdn.agro-mp.local/images/about-us/founders/belyi-founder.jpg',
                        name: 'Геннадий Белый'
                    },
                    {
                        id: 4,
                        src: '//cdn.agro-mp.local/images/about-us/founders/zulinskij-founder.jpg',
                        name: 'Дмитрий Зулинский'
                    },
                ],
            }
        },
        methods: {
            getPageInfo() {
                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getTextPage(this.pageName)
                    .then(res => {
                        this.data = res.data;
                    })
                    .catch(err => console.log(err))
            }
        },
        watch: {
            pageName: {
                handler() {
                    this.getPageInfo()
                },
                deep: true
            },
        },

        created() {
            this.getPageInfo();
        }
    }
</script>

<style scoped>

</style>
